import { useEffect } from "react";
import MoneyHero from "./common/hero";
import Personalize from "./common/personalize";
import LoanModal from "./common/loans";
import { useGetMoneyPageDataQuery } from "../../store/api/moneyApi";
import LoanOption from "./common/loanOptions";
import { FormProvider } from "./context/waitlist-context";

const header = {
  type: "Spend",
  title: "Find your ideal credit card with our experts",
  button: "Book Now",
  bgImage: "/assets/money/spend-header-bg.webp",
  image: "/assets/money/spend-header.webp",
  redirectUrl: "https://www.thepersonalcfo.in",
  theme: "#007aff",
  textColor: "white",
  imageClass: "w-[312px] h-[261px]",
};

const SpendComponent = () => {
  const { data, refetch } = useGetMoneyPageDataQuery("spend");
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    console.log(data);
  }, [data]);
  if (!data) return <></>;
  return (
    <div className="flex flex-col gap-8 max-w-[900px]">
      <FormProvider>
        <MoneyHero
          data={{
            ...header,
            redirectUrl: data?.data?.banner_button?.redirect_url,
          }}
        />
        <LoanOption investmentData={data?.data?.loans} />
        <Personalize />
        <LoanModal />
      </FormProvider>
    </div>
  );
};

export default SpendComponent;
